import BlockVideo from './block-video';

export default class BlockVideoDesktop extends BlockVideo {
	constructor(...args) {
		super(...args);
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/block-video/block-video.desktop.js